module.exports = __webpack_public_path__ + "img/step2-b.1df9d087.png";